export const options: ISelectOption<string>[] = [
    {
        value: 'CRITICAL_PATH_USER_CARD_BOARD',
        label: 'Critical Path',
    },
    {
        value: 'DELAY_DRIVER_CARD_BOARD',
        label: 'Delay Driver',
    },
    {
        value: 'IMPORTANT_PREDECESSOR_OVERDUE',
        label: 'Delayed predecessor',
    },
    {
        value: 'RCF_RISK',
        label: 'Forecasted Duration Risk',
    },
    {
        value: 'CONSTRAINT_DAY_SET',
        label: 'Hard Constraints',
    },
    {
        value: 'LONG_DURATION',
        label: 'Long Duration',
    },
    {
        value: 'IMPORTANT_LAG_CARD_30_BOARD',
        label: 'Long Lag/Lead',
    },
    {
        value: 'OVERDUE_CARD_BOARD',
        label: 'Overdue Progress',
    },
    {
        value: 'FINISH_PROG_OVERDUE_CARD_BOARD',
        label: 'Overdue Finish Date',
    },
    {
        value: 'START_PROG_OVERDUE_CARD_BOARD',
        label: 'Overdue Start Date',
    },
    {
        value: 'SET_BACK',
        label: 'Setback',
    },
    {
        value: 'IMPORTANT_STALLED',
        label: 'Stalled Activities',
    },
    {
        value: 'ANY_INDICATOR',
        label: 'Any Risk',
    },
];
